import {StyleSheet} from 'react-native';

import {COLORS} from '../../../utils/Constants';

export default StyleSheet.create({
  container: {
    alignItems: 'center',
    marginHorizontal: 56,
    margin: 16,
    marginBottom: 48,
  },
  lowerText: {
    marginTop: 8,
    textAlign: 'center',
  },
  image: {height: '300px', width: '300px'},
});
